
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  // import Constants from '@/common/constants';
  import text from '@/common/mixins/text';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import { getRuFormattedRangeDateWithMonthWord } from '@/common/utils/dates';
  import { downloadPDF } from '@/common/utils/fileExport';

  import CardEvent from '../components/events/CardEvent.vue';
  import { DASHBOARDS_VES_ACTIONS_NAME, DASHBOARDS_VES_GETTERS_NAME } from '../store/dashboards/name';
  import { EVENTS_CARD_VES_ACTIONS_NAME, EVENTS_CARD_VES_GETTERS_NAME } from '../store/eventsCardVES/name';

  export default defineComponent({
    name: 'EventsCardVES',
    mixins: [text],
    components: {
      PageTitle,
      CardEvent,
      ButtonComponent,
      IconComponent,
    },
    data(): {
      id: number;
      isSystemEvent: boolean;
      isExportProgress: boolean;
    } {
      return {
        id: Number(this.$route.params.id),
        isSystemEvent: this.$route.query.isSystemEvent === 'true',
        isExportProgress: false,
      };
    },
    async created() {
      if (this.isSystemEvent) this.getEventStatuses();
      const res = await this.getEventCard({ id: this.id, isSystemEvent: this.isSystemEvent });
      if (!res?.success) this.$router.push({ name: 'EventsVES' });
    },
    computed: {
      ...mapGetters({
        cardData: EVENTS_CARD_VES_GETTERS_NAME.getEventCard,
        eventStatuses: DASHBOARDS_VES_GETTERS_NAME.getEventStatuses,
      }),

      getEventStatus(): string {
        if (this.cardData.eventStatus) return this.cardData.eventStatus;

        const statusId = this.cardData.ferEventStatusId;
        const status = this.eventStatuses?.find((item: { id: number }) => item.id === statusId);
        return status?.name || '-';
      },

      getDatesRange() {
        const { startEventDate, endEventDate } = this.cardData;

        if (!startEventDate && !endEventDate) return '-';

        return getRuFormattedRangeDateWithMonthWord(startEventDate, endEventDate);
      },

      getPartnerCountries() {
        const items = this.cardData.partnerCountry;
        if (!Array.isArray(items) || !items.length) return '-';
        return items.map((item) => item.name).join(', ');
      },
    },
    methods: {
      ...mapActions({
        getEventCard: EVENTS_CARD_VES_ACTIONS_NAME.getEventCard,
        getEventStatuses: DASHBOARDS_VES_ACTIONS_NAME.getEventStatuses,
      }),

      async downloadPDF() {
        this.isExportProgress = true;
        await downloadPDF({
          clonedElementClassName: 'exportPdf',
          pagebreakMode: 'table-friendly',
          fileName: 'Карточка_мероприятия_по_ВЭС',
        });
        this.isExportProgress = false;
      },

      // formatCurrency(value: number) {
      //   return this.formatNumber(value / Constants.THOUSAND, 1);
      // },
    },
  });
